let meshoptBaseUrl = "https://cdn.babylonjs.com/";
function setMeshoptBaseUrl(url) {
  meshoptBaseUrl = url.endsWith("/") ? url : url + "/";
}
let scriptLoadPromise = null;
function loadMeshoptScript() {
  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }
  scriptLoadPromise = new Promise((resolve, reject) => {
    const existing = globalThis.MeshoptDecoder;
    if (existing) {
      resolve(existing);
      return;
    }
    const script = document.createElement("script");
    script.src = meshoptBaseUrl + "meshopt_decoder.js";
    const cleanup = () => {
      script.onload = null;
      script.onerror = null;
      script.remove();
    };
    const fail = (message) => {
      cleanup();
      reject(new Error(message));
    };
    script.onload = () => {
      const mod = globalThis.MeshoptDecoder;
      if (!mod) {
        fail("meshopt_decoder.js loaded but MeshoptDecoder is undefined");
      } else {
        cleanup();
        resolve(mod);
      }
    };
    script.onerror = () => fail("Failed to load meshopt_decoder.js from " + script.src);
    document.head.appendChild(script);
  });
  void scriptLoadPromise.catch(() => {
    scriptLoadPromise = null;
  });
  return scriptLoadPromise;
}
async function getMeshoptDecoder() {
  const mod = await loadMeshoptScript();
  await mod.ready;
  return mod;
}

export { getMeshoptDecoder, setMeshoptBaseUrl };
//# sourceMappingURL=meshopt-decode.js.map
